import * as React from 'react';
import { css } from '@emotion/core';
import ClamShell from '../layout/ClamShell';
import ActionMsg from '../localization/ActionMsg';
import { Str } from '../localization/translationKeys';
import { COLORS } from '../globalStyle/colors';


const styles = {
  root:   css`
    background-color: ${COLORS.RED};
  `,
  button: css`
    min-width: 80px;
  `,
};


type Props = {
  error: Str | string | number | undefined;
  showRetry?: boolean;
  onRetry?: () => void;
  className?: string;
};


/**
 * ErrorMsg: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ErrorMsg: React.FC<Props> = props => (
  <ClamShell show={!!props.error}>
    <ActionMsg
      className={props.className}
      msg={props.error}
      showBtn={props.showRetry}
      btnMsg={Str.Retry}
      btnStyle={styles.button}
      onClick={props.onRetry}
      css={styles.root}
    />
  </ClamShell>
);

export default ErrorMsg;
